export enum CareAssessmentsRoutes {
  CARE_ASSESSMENTS_QUESTIONNAIRE = 'careAssessmentsQuestionnaire',
  CARE_ASSESSMENTS_RETAKE = 'careAssessmentsRetake',
}
